import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">3-factor model of building
                                                rapport
                                            </div>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/factor-image.jpg')}
                                                    style={{width:'100%'}}/>
                                            </div>

                                            <div className="border_subtitle">1. Creating common ground</div>
                                            <p>Many factors come into play which affect your ability to build
                                                rapport and create common ground. The ‘similar to me’ bias and
                                                the ‘halo/horns’ effect are two to be aware of:</p>
                                            <ul className="greenbullet-list">

                                                <li>The ‘similar to me’ bias: we’re all attracted to types
                                                    similar to ourselves. The most obvious similarities are
                                                    gender, race and age, but others include personality and
                                                    interests. Emphasising your similarity to another, even in
                                                    small ways, helps build rapport. For example, on finding out
                                                    that the person you’re meeting is interested in sport,
                                                    mentioning your own, similar interest affirms something in
                                                    common.
                                                </li>
                                                <li className="list-bottom-pad">The ‘halo/horns’ effect: first
                                                    impressions are important. They’re so important that they
                                                    can actually determine the course of an entire encounter. If
                                                    the person you’re meeting makes a positive judgement of you
                                                    in the first minute or so, they are likely to interpret your
                                                    subsequent actions positively. If they don’t view you
                                                    positively in those first few seconds, they’re likely to
                                                    interpret the very same actions negatively. Paying attention
                                                    to making a good first impression is vital. This means
                                                    taking a relaxed, open approach and showing warmth by making
                                                    eye contact, initiating conversation and projecting a
                                                    positive attitude.
                                                </li>

                                            </ul>
                                            <p>So building rapport doesn’t require you to be somebody you’re
                                                not. It’s about engaging with another person and expressing a
                                                real interest in them.</p>

                                            <div className="border_subtitle">2. Body language</div>
                                            <p>Your body language reinforces the message of your words and can
                                                provide a wealth of information about how you’re feeling, what
                                                you’re really thinking and how comfortable you are. Some of the
                                                important elements are:</p>
                                            <ul className="greenbullet-list">

                                                <li><span
                                                    className="subtitle-table">Posture and distance</span> – How
                                                    close you are to the other person. Too close and you may
                                                    appear aggressive, too far away and you won’t have enough
                                                    ‘personal presence’. This also depends on the posture you
                                                    adopt.
                                                </li>
                                                <li><span className="subtitle-table">Eyes </span>– Can you
                                                    maintain the right level of eye contact? Try to maintain
                                                    relaxed and friendly eye contact without staring too much or
                                                    looking uninterested.
                                                </li>
                                                <li><span className="subtitle-table">Mouth</span> – When we’re
                                                    nervous, we often clench our jaws and tighten our mouths.
                                                    Try to relax this part of your face and smile to soften your
                                                    appearance to match your friendly words, or you may send
                                                    mixed, confusing messages.
                                                </li>
                                                <li className="list-bottom-pad"><span
                                                    className="subtitle-table">Gestures</span> – These include
                                                    waving your hands, fiddling with things, folding arms and
                                                    pointing fingers. Open arms and shrugging shoulders may
                                                    convey passivity or ‘giving up’, while excessive movements
                                                    can be distracting.
                                                </li>
                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }